import {FC, SVGProps} from 'react';

export const ForeignAccountPaymentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
		<path d="M3 10h18v1H3V10Z" fill="currentColor" />
		<path d="M5 11v9h2V11H5ZM9 11v9h2V11H9ZM13 11v9h2V11h-2ZM17 11v9h2V11h-2Z" fill="currentColor" />
		<path d="M12 3 21 10H3l9-7Z" fill="currentColor" />
	</svg>
);
